import axios from 'axios'
import { BANKING_API_ENDPOINT_V2 } from 'shared/envs'

import { httpClientFactory } from '~/domains/platform/infra/http/http-client-factory'
import { keysToSnakecase, transformResponse } from '~/domains/platform/infra/http/http-helpers'
import { responseUnauthorizedAccessInterceptor } from '~/domains/platform/infra/http/interceptors/unauthorized-access-interceptor'

export const httpClientBankingV2 = httpClientFactory({
  baseURL: BANKING_API_ENDPOINT_V2(),
  transformRequest: [keysToSnakecase, ...(axios.defaults.transformRequest as any[])],
  transformResponse: [...(axios.defaults.transformResponse as any[]), transformResponse],
  responseErrorInterceptors: [responseUnauthorizedAccessInterceptor]
})
